import { useMemo } from 'react'
import { browserVersion, isLegacyEdge, isMobileSafari, isSafari } from 'react-device-detect'

export interface UsePlacesBrowser {
  isOutdatedBrowserForAutocomplete: boolean
}

export const usePlacesBrowser = (): UsePlacesBrowser => {
  const isOutdatedBrowserForAutocomplete: boolean = useMemo(
    () =>
      ((isSafari || isMobileSafari) && Number(browserVersion) <= 13) ||
      (isLegacyEdge && Number(browserVersion) <= 15),
    [],
  )
  return { isOutdatedBrowserForAutocomplete }
}

export default usePlacesBrowser
